import localization from "../../../assets/localization";
import AiDisclosure from "../components/footer/AiDisclosure";
import PoweredBy from "../components/footer/PoweredBy";
import "../voice/voice.css";

interface ChatInputProps {
  inputMessage: string;
  setInputMessage: (value: string) => void;
  handleUserMessage: () => void;
  style: any;
  isEditor: boolean;
  isMessageCompleted: boolean;
  language: string;
  isMobile: boolean;
  assistantId: string;
  isVoiceMode: boolean;
  voiceModeEnabled: boolean;
  onVoiceToggle: () => void;
  showAiDisclosure: boolean;
}

export const ChatFooter = ({
  inputMessage,
  setInputMessage,
  handleUserMessage,
  style,
  isEditor,
  isMessageCompleted,
  language,
  isMobile,
  assistantId,
  isVoiceMode,
  voiceModeEnabled,
  onVoiceToggle,
  showAiDisclosure,
}: ChatInputProps) => {
  const t = localization.get(language);
  return (
    <>
      <div
        className="widget-chat-footer"
        style={{ backgroundColor: style.color }}
      >
        {showAiDisclosure && <AiDisclosure language={language} />}
        <div className="widget-chat-input-container border border-grey-400">
          {/* Mic / stop-voice button — only rendered when voice mode is enabled */}
          {voiceModeEnabled && (
            <button
              className={`widget-mic-button${
                isVoiceMode ? " widget-mic-button--active" : ""
              }`}
              style={{
                backgroundColor: isVoiceMode
                  ? "rgba(239,68,68,0.15)"
                  : "rgba(255,255,255,0.15)",
                color: style.color,
              }}
              disabled={isEditor}
              onClick={onVoiceToggle}
              aria-label={
                isVoiceMode ? t.voice_panel.stop_mode : t.voice_panel.start_mode
              }
              title={
                isVoiceMode ? t.voice_panel.stop_mode : t.voice_panel.start_mode
              }
            >
              {/* Animated wave bars — always shown, red tint when active */}
              <span className="widget-mic-wave">
                <span />
                <span />
                <span />
                <span />
              </span>
            </button>
          )}

          <textarea
            className="widget-chat-input"
            disabled={isEditor || isVoiceMode}
            placeholder={t.type_a_message}
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyDown={(event) => {
              event.stopPropagation();

              if (event.key === "Enter") {
                event.preventDefault();

                if (isMessageCompleted) handleUserMessage();
              }
            }}
          />
          <button
            disabled={!isMessageCompleted || isEditor || isVoiceMode}
            className="widget-send-button flex-none m-0 p-0 text-white"
            style={{ backgroundColor: style.color }}
            onClick={handleUserMessage}
            aria-label={t.send_aria_label}
          >
            <i
              className="fa-solid fa-paper-plane"
              style={{ color: "white", fontSize: "1.2rem" }}
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <PoweredBy language={language} assistantId={assistantId} />
      </div>
    </>
  );
};
